<template>
  <div
    ref="parent"
    class="form-group">
    <label>{{ label }}</label>
    <input
      v-bind:class="{lowercase: lowercase, marginExtra: margin}"
      ref="input"
      :disabled="disabled"
      :type="type"
      :error="error"
      :placeholder="placeholder"
      :value="value"
      :step="step"
      v-on="listeners"
      :autocomplete="autocomplete"/>
    <div
      :class="error ? 'error-message' : 'hidden'">
      <font-awesome-icon
        :icon="infoCircle"/>
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    margin: {default: true, type: Boolean},
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    step: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lowercase: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      // For possible values please refer to:
      // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
      type: String,
      default: 'on'
    }
  },
  computed: {
    listeners () {
      return {
        input: event => this.$emit('input', event.target.value),
        click: event => this.$emit('click', event)
      };
    },
    infoCircle () {
      return faInfoCircle;
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

$form-minw: $sp * 50;

.marginExtra {
  margin-bottom: $sp-margin-large;
}
.form-group {
  display: block;
  label {
    display: block;
    color: $black-trans4;

    .form--inverse & {
      color: $white-trans4;
    }
  }
  input {
    background-color: $white;
    border: 1px solid $black-trans6;
    border-radius: $radius;
    padding-left: $sp-margin-small;
    padding-right: $sp-margin-small;
    height: $height3;
    //TODO: HOW TO OVERRIDE THIS SETTING?
    //min-width: $form-minw;
    width: 100%;
    caret-color: $active;
    &:disabled {
      background: $disabled;
    }
    &::placeholder {
      color: $black-trans6;
    }
    &:hover {
      border-color: $black-trans4;
    }
    &:focus,
    &:active {
      outline: 0;
      border-color: $active;
    }

    .form--inverse & {
      background-color: transparent;
      border-color: $white-trans6;
      color: $white;
      &::placeholder {
        color: $white-trans6;
      }
      &:hover {
        border-color: $white-trans4;
      }
      &:focus,
      &:active {
        border-color: $active;
      }
    }
    &[error="true"] {
      border-color: $error;
    }
  }
  .error-message {
    color: $error;
  }
  .hidden {
    visibility: hidden;
  }
}

.lowercase {
  text-transform: lowercase;
}

@mixin form-size($font-size, $height) {
  .form-group,
  &.form-group {
    font-size: $font-size;
  }
  input {
    height: $height;
  }
}
[form-size="xs"] {
  @include form-size($fs-xs, $height1);
}
[form-size="s"] {
  @include form-size($fs-s, $height2);
}
[form-size="m"] {
  @include form-size($fs, $height3);
}
[form-size="l"] {
  @include form-size($fs-xl, $height5);
}

</style>



// WEBPACK FOOTER //
// src/components/shared/forms/LabelInput.vue